import { render, staticRenderFns } from "./AppleAddToHomeScreenModal.vue?vue&type=template&id=74be5d20&scoped=true&"
import script from "./AppleAddToHomeScreenModal.vue?vue&type=script&lang=js&"
export * from "./AppleAddToHomeScreenModal.vue?vue&type=script&lang=js&"
import style0 from "./AppleAddToHomeScreenModal.vue?vue&type=style&index=0&id=74be5d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74be5d20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VSpacer})
